import { render, staticRenderFns } from "./logout_index.vue?vue&type=template&id=ef7b5752"
import script from "./logout_index.vue?vue&type=script&lang=js"
export * from "./logout_index.vue?vue&type=script&lang=js"
import style0 from "./logout_index.vue?vue&type=style&index=0&id=ef7b5752&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports